/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_4Inputs */

const en_us2_onboarding_parq_4 = /** @type {(inputs: Onboarding_Parq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you lose balance because of dizziness, or have you ever lost consciousness?`)
};

const pt_br2_onboarding_parq_4 = /** @type {(inputs: Onboarding_Parq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você perde o equilíbrio por tontura ou já perdeu a consciência?`)
};

const es_419_onboarding_parq_4 = /** @type {(inputs: Onboarding_Parq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Pierdes el equilibrio por mareos o alguna vez has perdido el conocimiento?`)
};

const pt_pt2_onboarding_parq_4 = /** @type {(inputs: Onboarding_Parq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdes o equilíbrio por causa de tonturas, ou já perdeste a consciência?`)
};

const fr_fr2_onboarding_parq_4 = /** @type {(inputs: Onboarding_Parq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perds-tu l'équilibre à cause d'étourdissements, ou as-tu déjà perdu connaissance ?`)
};

const de_de2_onboarding_parq_4 = /** @type {(inputs: Onboarding_Parq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlierst du wegen Schwindel das Gleichgewicht, oder hast du schon einmal das Bewusstsein verloren?`)
};

const it_it2_onboarding_parq_4 = /** @type {(inputs: Onboarding_Parq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdi l'equilibrio a causa di capogiri, o hai mai perso conoscenza?`)
};

/**
* | output |
* | --- |
* | "Do you lose balance because of dizziness, or have you ever lost consciousness?" |
*
* @param {Onboarding_Parq_4Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_4 = /** @type {((inputs?: Onboarding_Parq_4Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_4Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_4(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_4(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_4(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_4(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_4(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_4(inputs)
	return en_us2_onboarding_parq_4(inputs)
});
export { onboarding_parq_4 as "onboarding.parq.4" }